// extracted by LIB_CSS_EXTRACT_LOADER
import "./kbd_module.css"
export default {"kbd":"kbd-HTqlZL","group":"group-dY862Z"};